<template>
	<div class="login">
		<div class="logo" @click="toHome">
			<img src="../../assets/images/icon/logo.png" alt="">
		</div>
		<div class="login_box">
			<div class="title">Sign up</div>
			<div class="input_box">
				<input type="text" placeholder="First name*" v-model="first_name">
			</div>
			<div class="input_box">
				<input type="text" placeholder="Last name*" v-model="last_name">
			</div>
			<div class="input_box">
				<input type="text" placeholder="Mobile*" v-model="mobile">
			</div>
			<div class="input_box">
				<img src="../../assets/images/icon/user.png" alt="">
				<input type="text" v-model="email" placeholder="Email">
			</div>
			<div class="input_box">
				<img src="../../assets/images/icon/pwd.png" alt="">
				<input type="text" v-model="code" placeholder="Verification code">
				<div class="code" @click="getNub">{{codeStatus ? codeNub : 'Send Code'}}</div>
			</div>
			<div class="input_box">
				<img src="../../assets/images/icon/pwd.png" alt="">
				<input type="text" v-model="pwd" placeholder="Password">
			</div>
			<div class="input_box">
				<img src="../../assets/images/icon/pwd.png" alt="">
				<input type="text" v-model="confirmPassword" placeholder="Confirm password">
			</div>
			<div class="btn_list flex align-center">
				<div class="agree flex align-center" @click="selectStatus = !selectStatus">
					<div class="select" v-if="!selectStatus"></div>
					<img class="select" v-else  src="../../../src/assets/images/icon/select_active.png" alt="">
					<div>I hereby agree to the <span @click.stop="toTerm">《Terms and Conditions》</span></div>
				</div>
				<!-- <div class="forget" @click="toFileInfo">忘记密码</div> -->
			</div>
			<div class="submit" @click="submit">Sign up</div>
		</div>
		<div class="bottom_help flex align-center justify-center">
			<div><span>Contact : info@Curiouser-family.com </span> Telephone: +44 (0)7462258770</div>
			<!-- <div class="help">帮助</div> -->
		</div>
		<div class="model" v-if="selectModel" @click="selectModel = false">
			<div class="model_content" @click.stop="">
				<div class="detail" v-html="detail.privacy_policy"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				email:'',
				pwd:'',
				code:'',
				selectStatus:false,
				codeStatus:false,
				codeNub:300,
				sendStatus:false,
				submitStatus:false,
				selectModel:false,
				detail:{},
				confirmPassword:'',
				first_name:'',
				last_name:'',
				mobile:''
			}
		},
		methods:{
			toHome(){
				this.$router.push('/home')
			},
			submit(){
				if(this.submitStatus){
					return
				}
				var params = {
					password:this.pwd,
					email:this.email,
					code:this.code,
					first_name:this.first_name,
					last_name:this.last_name,
					mobile:this.mobile
				}
				if(!this.first_name){
					this.$message('First Name is Required');
					return
				}
				if(!this.last_name){
					this.$message('Last name is Required');
					return
				}
				if(!this.mobile){
					this.$message('Mobile is Required');
					return
				}
				if(!this.pwd){
					this.$message('Please enter a password')
					return
				}
				if(!this.selectStatus){
					this.$message('Please agree to the Terms and Conditions')
					return
				}
				if(this.pwd != this.confirmPassword){
					this.$message('Your password and confirmation password do not match')
					return
				}
				if(!this.code){
					this.$message('Please enter the 4 digit code that was sent to your email address')
					return
				}
				this.submitStatus = true
				this.$api.post('user/registerByEmail',params,res=>{
					if(res.code == 1){
						this.$message('Successful')
						localStorage.setItem('token',res.data.token)
						setTimeout(()=>{
							this.$router.push('/fileInfo')
						},1000)
					}else{
						this.submitStatus = false
						this.$message(res.msg)
					}
				})
			},
			getNub(){
				var that = this;
				if(this.sendStatus){
					return;
				}
				this.sendStatus = true;
				var params = {
					event:'register',
					email:this.email
				}
				if(!this.email){
					this.$message('Please enter a valid email address');
					this.sendStatus = false;
					return;
				}
				this.$api.post('ems/send',params,res=>{
					if(res.code == 1){
						that.sendStatus = false;
						that.codeStatus = true;
						var codeTime = setInterval(function() {
							if (that.codeNub == 0) {
								clearInterval(codeTime)
								that.codeStatus = false
							} else {
								that.codeNub--
							}
						}, 1000)
					}else{
						this.sendStatus = false;
						this.$message(res.msg)
					}
				})
			},
			toTerm(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
						this.selectModel = true;
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.login{
		width: 100%;
		min-height: 100vh;
		background-color: #F7F2EB;
		padding-top: 70px;
		padding-bottom: 40px;
		.logo{
			width: 557px;
			height: 120px;
			margin: 0 auto;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.login_box{
			width: 550px;
			background: #F7F2EB;
			box-shadow: 0px 8px 16px 0px rgba(92, 112, 122, 0.3);
			border-radius: 10px;
			margin: 110px auto;
			padding: 30px;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-bottom: 20px;
			}
			.input_box{
				width: 472px;
				padding-bottom:30px;
				padding-top: 48px;
				position: relative;
				border-bottom: 1px solid #CCCCCC;
				position: relative;
				img{
					width: 25px;
					height: 28px;
					position: absolute;
					left: 0;
					top: 48px;
				}
				input{
					width: 100%;
					font-size: 16px;
					line-height: 40px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #999999;
					padding-left: 50px;
				}
				.code{
					position: absolute;
					right: 5px;
					top: 50%;
					transform: translateY(-50%);
					cursor: pointer;
					// width: 190px;
					// height: 80px;
					// background: #5C707A;
					// border-radius: 10px;
					// text-align: center;
					// line-height: 80px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #666;
				}
			}
			
			.btn_list{
				padding: 20px 57px 0 0;
				.agree{
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					cursor: pointer;
					span{
						color: #5C707A;
					}
					.select{
						width: 14px;
						height: 14px;
						border: 1px solid #282E30;
						border-radius: 50%;
						margin-right: 10px;
					}
				}
				.forget{
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #5C707A;
					cursor: pointer;
				}
			}
			.submit{
				width: 180px;
				height: 50px;
				background: #5C707A;
				border-radius: 29px;
				margin: 70px auto 0;
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				line-height: 50px;
				text-align: center;
				cursor: pointer;
			}
		}
		.bottom_help{
			margin-top: 160rpx;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			span{
				margin-right: 50px;
			}
			.help{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin-left: 56rpx;
				cursor: pointer;
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
		}
		
	}
</style>